export interface ISupportFile {
  image: string | ArrayBuffer | null;
  item: File;
  valid: boolean;
  reason?: 'limit' | 'maxSize';
}
